"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.get = void 0;
var crokinoleLayers_sidecar_1 = require("@crokinole/scene/crokinoleLayers-sidecar");
var diveColors_1 = require("@dive/colors/diveColors");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var largeSprites_1 = require("@sprites/largeSprites");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var crokinoleDefs_sidecar_1 = require("../main/crokinoleDefs-sidecar");
var crokinoleGameState_1 = require("../main/crokinoleGameState");
var crokinoleGameState_sidecar_1 = require("../main/crokinoleGameState-sidecar");
var namespace = 'crokinole_board';
var _obj = null;
function get() {
    // assert.notNil(_obj, 'board not loaded')
    if (!_obj) {
        create();
    }
    assert_sidecar_1.assert.notNil(_obj);
    return _obj;
}
exports.get = get;
var create = function () {
    var imageBoard = spritesUtil_sidecar_1.spritesUtil.createLargeSprite(crokinoleLayers_sidecar_1.crokinoleLayers.getLayers().board, largeSprites_1.largeSprites.crokinoleBoardInk);
    imageBoard.setOrigin(0.5, 0.5);
    imageBoard.setScale(0.5, 0.5);
    var imageStartingLineArc = spritesUtil_sidecar_1.spritesUtil.createLargeSprite(crokinoleLayers_sidecar_1.crokinoleLayers.getLayers().board, largeSprites_1.largeSprites.startingLineArc);
    imageStartingLineArc.setOrigin(0.5, 0.5);
    imageStartingLineArc.setScale(0.5, 0.5);
    imageStartingLineArc.tint = diveColors_1.diveColors.green;
    imageStartingLineArc.alpha = 0.5;
    var obj = {
        imageBoard: imageBoard,
        imageStartingLineArc: imageStartingLineArc,
    };
    _obj = obj;
};
var update = function () {
    var _a = get(), imageBoard = _a.imageBoard, imageStartingLineArc = _a.imageStartingLineArc;
    imageBoard.x = -voyageCamera_sidecar_1.voyageCamera.get().cameraX;
    imageBoard.y = -voyageCamera_sidecar_1.voyageCamera.get().cameraY;
    imageBoard.tint = diveColors_1.diveColors.pureWhite;
    var offsetY = 265 * crokinoleDefs_sidecar_1.crokinoleDefs.physicsMultiplier * crokinoleDefs_sidecar_1.crokinoleDefs.physicsScale;
    var offsetX = 265 * crokinoleDefs_sidecar_1.crokinoleDefs.physicsMultiplier * crokinoleDefs_sidecar_1.crokinoleDefs.physicsScale;
    var pp = crokinoleGameState_sidecar_1.crokinoleGameState.getCrokinolePlayerPosition(crokinoleGameState_sidecar_1.crokinoleGameState.getCurrentPlayer());
    var quad = pp.quadrant;
    if (quad === 0) {
        offsetX = 0;
        offsetY = offsetY;
        imageStartingLineArc.rotation = 0;
    }
    if (quad === 2) {
        offsetX = 0;
        offsetY = -offsetY;
        imageStartingLineArc.rotation = mathUtils_sidecar_1.mathUtils.turn(1 / 2);
    }
    if (quad === 1) {
        offsetX = -offsetX;
        offsetY = 0;
        imageStartingLineArc.rotation = mathUtils_sidecar_1.mathUtils.turn(1 / 4);
    }
    if (quad === 3) {
        offsetX = offsetX;
        offsetY = 0;
        imageStartingLineArc.rotation = mathUtils_sidecar_1.mathUtils.turn(-1 / 4);
    }
    imageStartingLineArc.visible =
        crokinoleGameState_sidecar_1.crokinoleGameState.get().state === crokinoleGameState_1.CrokinoleGameStates.place;
    imageStartingLineArc.x = -voyageCamera_sidecar_1.voyageCamera.get().cameraX - offsetX;
    imageStartingLineArc.y = -voyageCamera_sidecar_1.voyageCamera.get().cameraY - offsetY;
};
exports.update = update;
